import { createClient } from '@prismicio/client';

export const prismicRepository = 'apply-gotoitcareer';
export const prismicClient = createClient(prismicRepository);
